var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",style:(_vm.loaderStyle)},[_c('div',{staticClass:"dot-box"},[_c('div',{staticClass:"dot dot-1",style:(_vm.dotStyle)}),_c('div',{staticClass:"dot dot-2",style:(_vm.dotStyle)}),_c('div',{staticClass:"dot dot-3",style:(_vm.dotStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }